// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"77777257","732":"0ea192c3","977":"b94d2b65"}[chunkId] + ".chunk.js";
};